const numberFormatCache: Record<string, Intl.NumberFormat> = {};

export const formatNumber = (locale: string, value: number, options?: { avoidTrailingZero?: boolean }): string => {
  let formatter = numberFormatCache[locale];
  if (!formatter) {
    formatter = new Intl.NumberFormat(numberFormatterLocal(locale), {
      minimumFractionDigits: options?.avoidTrailingZero ? 0 : undefined,
    });
    numberFormatCache[locale] = formatter;
  }
  return formatter.format(value);
};

const exceptionLocales = new Set(['ar', 'fa', 'bn']);

/**
 * Adjusts number formatting for exception locales, defaulting to Western Arabic numeral system.
 * @param {string} locale - The user's local (Example: 'en', 'de', etc.).
 * @return {string} - Adjusted locale for number formatters.
 */
export const numberFormatterLocal = (locale: string): string =>
  exceptionLocales.has(locale) ? 'ar-u-nu-latn' : locale;
